import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { Loader2 } from 'lucide-react';
import { useAlbumNavigation } from "@/hooks/useAlbumNavigation";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdmin, isSuperadmin, loading } = useAdminAuth();
  const { getAlbumPath, loading: albumLoading } = useAlbumNavigation();

  if (loading || albumLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" />
          <p className="text-muted-foreground">Verificando permisos de administrador...</p>
        </div>
      </div>
    );
  }

  // Since superadmin has all admin privileges, we only need to check isAdmin
  // (context already sets isAdmin=true when isSuperadmin=true)
  if (!isAdmin) {
    const inicioPath = getAlbumPath("/inicio");
    return <Navigate to={inicioPath || "/"} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;